import { Component, OnInit, ViewChild, Input, Output, EventEmitter, ChangeDetectionStrategy, ChangeDetectorRef } from '@angular/core';
import { ProjectionUploaderComponent } from '../projection-uploader/projection-uploader.component';
import { ViewStackComponent } from '../view-stack/view-stack.component';
import { ProjectionDefinition } from 'proj4';
import { TypeAheadPrjRecord } from '../projection-typeahead/projection-typeahead.component';
import { ActionGroupComponent } from '../action-group/action-group.component';
import { LngLatLike } from 'mapbox-gl';
import { GeoLoc } from 'src/app/types/@types/sl-v-types';
import proj4 from 'proj4';

@Component({
  selector: 'app-projection-selector',
  templateUrl: './projection-selector.component.html',
  styleUrls: ['./projection-selector.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ProjectionSelectorComponent implements OnInit {
  private proj4Converter?: proj4.Converter;
  private _prjText = '';
  @Input()
  public set prjText(txt: string) {
    if (this._prjText !== txt) {
      this._prjText = txt;
      this.proj4Converter = proj4(this._prjText, 'EPSG:4326');
      this.Update();
      this.prjTextChange.emit(txt);
      this.changes.detectChanges();
    }
  }
  public get prjText(): string {
    return this._prjText;
  }
  @Output()
  prjTextChange = new EventEmitter<string>();

  private _prjJson: any = {}
  @Input('prjJson')
  set prjJson(prj: any) {
    if (JSON.stringify(prj) == JSON.stringify(this._prjJson)) {
      return;
    }
    this._prjJson = prj;
    this.prjJsonChange.emit(this._prjJson);
  }
  get prjJson(): any {
    return this._prjJson;
  }
  @Output()
  public prjJsonChange = new EventEmitter<any>();


  private _lngLat?: LngLatLike;
  @Input('lngLat')
  set lngLat(lngLat: LngLatLike | undefined) {
    if (!!lngLat) {
      if (JSON.stringify(lngLat) == JSON.stringify(this._lngLat)) {
        return;
      }
    }
    this._lngLat = lngLat;
    this.lngLatChange.emit(this._lngLat);
  }
  get lngLat(): LngLatLike | undefined {
    return this._lngLat;
  }
  @Output()
  lngLatChange = new EventEmitter<LngLatLike>();

  private _srcValue?: GeoLoc;
  @Input('srcValue')
  set value(val: GeoLoc | undefined) {
    this._srcValue = val;
    this.Update();
  }
  get value(): GeoLoc | undefined {
    return this._srcValue;
  }

  @ViewChild('uploader', { static: true }) uploader: ProjectionUploaderComponent;
  @ViewChild('views', { static: true }) views: ViewStackComponent;
  @ViewChild('actions', { static: true }) actions: ActionGroupComponent;
  constructor(private changes: ChangeDetectorRef) { }

  ngOnInit(): void {
    window.requestAnimationFrame(() => {
      this.proj4Converter = proj4('EPSG:4326', 'EPSG:4326');
      this.actions.SetSelected('Search by name', true);
      this.views.SetView('search')
    })
  }
  EnterCode() {
    this.views.SetView('code');
  }
  CodeChange(event) {

  }
  Search() {
    this.views.SetView('search');
  }
  ShowPrj(prjInfo: TypeAheadPrjRecord) {
    if (this.uploader) {
      this.uploader.SetSRS(prjInfo.sr);
    }
    this.views.SetView('uploader');
    this.actions.SetSelected('Drag and Drop a prj file', true);
  }
  Paste() {
    this.views.SetView('uploader');
    if (this.uploader) {
      this.uploader.PasteSRS();
    }

  }
  Import() {
    this.views.SetView('uploader');
    if (this.uploader) {
      this.uploader.RequestUpload();
    }
  }
  AllowDrop() {
    this.views.SetView('uploader');
    if (this.uploader) {
      this.uploader.SetSRS('');
      this.uploader.ShowText();

    }
  }
  Update() {
    if (!this._prjText) return;
    if (!!this._prjText) {
      if (!this._srcValue) return;
    }
    const projLngLat = this.proj4Converter.forward([this._srcValue.lng, this._srcValue.lat]);
    this.lngLat = { lng: projLngLat[0], lat: projLngLat[1] }


  }
}
